import { render, staticRenderFns } from "./GalleryDefault.vue?vue&type=template&id=64032b37&scoped=true"
import script from "./GalleryDefault.vue?vue&type=script&lang=js"
export * from "./GalleryDefault.vue?vue&type=script&lang=js"
import style0 from "./GalleryDefault.vue?vue&type=style&index=0&id=64032b37&lang=scss&scoped=true"
import style1 from "./GalleryDefault.vue?vue&type=style&index=1&id=64032b37&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64032b37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64032b37')) {
      api.createRecord('64032b37', component.options)
    } else {
      api.reload('64032b37', component.options)
    }
    module.hot.accept("./GalleryDefault.vue?vue&type=template&id=64032b37&scoped=true", function () {
      api.rerender('64032b37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/gallery/GalleryDefault.vue"
export default component.exports